import {Injectable} from '@angular/core';
import {NEVER, Observable} from 'rxjs';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {GlobalSettingsService} from '../services/ui/global-settings.service';
import {catchError, tap} from 'rxjs/operators';
import {JobProcedureService} from '../services/sections/job/job-procedure.service';
import {JobStatusTypes} from '../models/enum/job-status-types.enum';
import { JobProcedureFormBypassRequestDetails } from '../models/jobProcedureFormBypassRequestDetails';

@Injectable({providedIn: 'root'})
export class ProcedureFormBypassResolver implements Resolve<Observable<JobProcedureFormBypassRequestDetails>>{
	constructor(
		private router: Router,
		private jobProcedureService: JobProcedureService
	) {}
	resolve(route: ActivatedRouteSnapshot): Observable<JobProcedureFormBypassRequestDetails> {
		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.jobProcedureService
			.getJobBypassRequiredRequest(route.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				tap((result) => {
					GlobalSettingsService.preferencesPayloadForJobDetails.jobProcedureFormBypassRequestDetails = result;
				}),
			);
	}
}
